import { runJsonGet, runJsonPost } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import {
  OrderAssignmentFiltersRequest,
  OrderAssignmentsResponse
} from './models/order-assignments-model'
import { transformKeysToCamelCase } from './utils/casing'

export const fetchOrderAssignments: (
  params: Partial<OrderAssignmentFiltersRequest>
) => Promise<OrderAssignmentsResponse> = async params => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/order-assignments/queries/get-order-assignments`,
    params
  )
  return transformKeysToCamelCase(data)
}

export const acceptOrderAssignment: (id: number) => Promise<void> = async id => {
  await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/order-assignments/commands/accept-assignment/${id}`
  )
}

export const rejectOrderAssignment: (id: number) => Promise<void> = async id => {
  await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/order-assignments/commands/reject-assignment/${id}`
  )
}
